import React from "react";
import profile from "../images/linkedin.png";
import { useRef , useState, useEffect } from "react";
import { FaMouse, FaChevronDown } from "react-icons/fa";
import "../style/intro.css";
import Contact from "./contact";


const Intro = () => {
  const main = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showScrollHint, setShowScrollHint] = useState(true);

  const handlePopupToggle = () => {
    setShowPopup(!showPopup);
  };

  useEffect(() => {
    const onScroll = () => {
      setShowScrollHint(window.scrollY < 40);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      
      <div className="container">
        <div ref={main} className="main_container">
          <div
            className="r_container"
            data-aos="flip-down"
            data-aos-duration="800"
          >
            <div
              className="shape s1"
              data-aos="fade-down"
              data-aos-duration="2000"
            ></div>
            <div
              className="shape s2"
              data-aos="fade-up"
              data-aos-duration="2000"
            ></div>
            <img className="box" src={profile} alt="" />
          </div>
          <div>
        <button className="button-50 move"  onClick={handlePopupToggle}>Contact</button>
      </div>
      <button
        type="button"
        className={`scroll-hint${showScrollHint ? "" : " is-hidden"}`}
        onClick={() => document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })}
        aria-label="Scroll down"
      >
        <FaMouse className="scroll-hint-mouse" />
        <span className="scroll-hint-arrows">
          <FaChevronDown />
          <FaChevronDown />
        </span>
      </button>
      <Contact showPopup={showPopup} handlePopupToggle={handlePopupToggle} />

        </div>
      </div>
    </>
  );
};

export default Intro;
